import moment from 'moment'
const INVENTORY_ADJUSTMENT_LOG_REASON_CHOIES = {
    R: 'Returning a Rental',
    D: 'Damaged',
    S: 'Scrapped',
    C: 'Cycle Count'
}


export function createLogsList(equipment) {
    let list = []

    // shipping logs
    equipment.shippingLogs.forEach(log => {
        let listItem = {
            id: `${log.id} - shipping`
        }

        // date
        listItem['date'] = moment(log.dateAndTime).format("M/D/YYYY")
        // type
        listItem['typeTitle'] = 'Shipping'
        listItem['typeSubTitle'] = log.toJob ? `to: ${log.toJob.name}` : null

        // amount
        listItem['amountTitle'] = log.quantity
        // createdBy
        listItem['createdBy'] = log.createdBy ? `${log.createdBy.firstName} ${log.createdBy.lastName}` : null

        list.push(listItem)
    })

    // adjustment logs
    equipment.adjustmentLogs.forEach(log => {
        let listItem = {
            id: `${log.id} - adjustment`
        }

        // date
        listItem['date'] = moment(log.dateAndTime).format("M/D/YYYY")
        // type
        listItem['typeTitle'] = 'Adjustment'
        listItem['typeSubTitle'] = INVENTORY_ADJUSTMENT_LOG_REASON_CHOIES[log.reason]
        // amount
        listItem['amountTitle'] = log.quantity
        // createdBy
        listItem['createdBy'] = log.createdBy ? `${log.createdBy.firstName} ${log.createdBy.lastName}` : null

        list.push(listItem)
    })

    // receiving logs
    equipment.receivingLogs.forEach(log => {
        let listItem = {
            id: `${log.id} - receiving`
        }

        // date
        listItem['date'] = moment(log.dateAndTime).format("M/D/YYYY")
        // type
        listItem['typeTitle'] = 'Receiving'
        listItem['typeSubTitle'] = log.fromJob ? log.fromJob.name : log.fromPurchaseOrder ? `P.O. #${log.fromPurchaseOrder.number}` : null
        // amount
        listItem['amountTitle'] = log.quantity
        // createdBy
        listItem['createdBy'] = log.createdBy ? `${log.createdBy.firstName} ${log.createdBy.lastName}` : null

        list.push(listItem)
    })

    // cycle count logs
    equipment.cycleCountLogs.forEach(log => {
        let listItem = {
            id: `${log.id} - cycleCount`
        }

        // date
        listItem['date'] = moment(log.dateCounted).format("M/D/YYYY")
        // type
        listItem['typeTitle'] = 'Cycle Count'
        // amount
        listItem['amountTitle'] = `Expected: ${log.expectedQuantity}`
        listItem['amountSubTitle'] = `Counted: ${log.countedQuantity}`
        // createdBy
        listItem['createdBy'] = log.createdBy ? `${log.createdBy.firstName} ${log.createdBy.lastName}` : null

        list.push(listItem)
    })


    return list
}